export const LogoMark = ({ className = "h-10 w-10" }) => (
  <img src="/media/logo-mark.png" alt="" aria-hidden="true" className={`object-contain ${className}`} />
);

export const Logo = ({ light = false }) =>
  light ? (
    <span className="inline-flex rounded-2xl bg-white px-5 py-4" data-testid="site-logo">
      <img src="/media/logo-nexus.png" alt="Nexus Italia Group" className="h-14 w-auto" />
    </span>
  ) : (
    <span className="flex items-center" data-testid="site-logo">
      <img src="/media/logo-nexus.png" alt="Nexus Italia Group" className="h-14 w-auto sm:h-16" />
    </span>
  );
